<div style="background-color: #FAFAFA;">
    <router-outlet></router-outlet>
</div>
